import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';

// export const chartBox = {
//   chartBox: {
//     titleBgColor: base.color.c0029,
//     contentBgColor: comm.color.cffff,
//   },
// };

const chartBoxTheme = {};
for (const item of Object.keys(brandCodeMap)) {
  chartBoxTheme[item] = {
    chartBox: {
      titleBgColor: base[item]?.chartBoxColor.c0029, // 标题背景
      contentBgColor: comm.color.cffff, // 内容背景
      TypeChangeBtnGroupColor: [
        base[item]?.chartBoxColor.c0001, //选中的颜色
        base[item]?.chartBoxColor.c0002, //未选中的颜色
      ], //图表条件切换的文字颜色
      // nc0003: base[item]?.chartColor.nc0003, // 区域横线的颜色
      // nc0004: base[item]?.chartColor.nc0004, // 柱状图的颜色列表
      // nc0005: base[item]?.chartColor.nc0005, // 折线图的颜色列表
      // nc0006: base[item]?.chartColor.nc0006, // 饼图的颜色列表
      // // 这五个是红色变浅五个柱图
      // c0001: base[item]?.chartColor.c0001,
      // c0002: base[item]?.chartColor.c0002,
      // c0003: base[item]?.chartColor.c0003,
      // c0004: base[item]?.chartColor.c0004,
      // c0005: base[item]?.chartColor.c0005,
      // c0011: base[item]?.chartColor.c0011, // 蓝色
      // c0012: base[item]?.chartColor.c0012, // y轴字体颜色
      // c0014: base[item]?.chartColor.c0014, // x轴字体颜色
      // c0025: base[item]?.chartColor.c0025, // 深红
    },
  };
}

export const chartBox = chartBoxTheme;
